import React, { Component } from 'react'
//import axios from "axios";
//import { Link } from "react-router-dom";
export class ContactinfoList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sbg_list: [],
        }
    }

    componentDidMount() {

        this.setState({
            userId: localStorage.getItem("userId")
        })

        // axios.get('https://levashubhmangal.com/web_service_14072020/Suchi_bride_groom_relatives_view.php?sbg_id='+localStorage.getItem("userId"))
        // .then(function (response)
        //  {
        //      // handle success
        //      //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
        //      this.setState({ sbg_list:response.data.relatives_list})
        //  }.bind(this))
        // .catch(function (error) 
        // {
        //    // handle error
        //    console.log(error);
        // })
        // .then(function () {
        //    // always executed
        // });
    }


    render() {
        //let sbg_list =this.props.persons;

        let count = 0;
        let renderTableData =
            this.props.sbg_list.map((slist, index) => {
                count++;
                const { sbgr_id, sbgr_prifix, sbgr_person_name, sbgr_bride_groom_relation, sbgr_Mobile_no1, sbgr_Mobile_no2, sbgr_address } = slist //destructuring
                return (
                    <tr key={sbgr_id}>

                        <td>{sbgr_prifix}. {sbgr_person_name}</td>
                        <td>{sbgr_bride_groom_relation}</td>
                        <td>{sbgr_Mobile_no1}</td>
                        <td>{sbgr_Mobile_no2}</td>
                        <td>{sbgr_address}</td>
                        <td>

                            <button type="button" onClick={() => this.props.editshow(sbgr_id)} >
                                🖊️
                            </button> &nbsp;&nbsp;
                            <button type="button" onClick={() => this.props.deleteshow(sbgr_id, count)} >
                                ❌
                            </button>
                            {/* <Link to={`/FormProfile/ContactInfo/${sbgr_id}`}>
                    🖊️
               </Link> */}
                            {/* <span onClick={()=>this.deleteRecoed(h_id)} >
                    Delete 
               </span> */}
                        </td>
                    </tr>
                )
            })


        return (
            <div>
                <table class="table table-danger table-striped">
                    <thead>
                        <tr>

                            <th scope="col">व्यक्तीचे संपूर्ण नाव</th>
                            <th scope="col">वधू वरसोबत असलेले नाते</th>
                            <th scope="col">मोबाइल नंबर 1</th>
                            <th scope="col">मोबाइल नंबर 2</th>
                            <th scope="col">पत्ता</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderTableData}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default ContactinfoList
